export class ForgeProjectFeatureMessageReaction {
    constructor(model) {
        this.messageId = model.messageId;
        this.userId = model.userId;
        this.emoji = model.emoji;
        this.createdAt = new Date(model.createdAt);
    }
    toRemote() {
        return {
            ...this,
            createdAt: this.createdAt.toISOString(),
        };
    }
}
